import main3img1 from '@/assets/main/main3/main3img1.png'
import main3img2 from '@/assets/main/main3/main3img2.png'
import main3img3 from '@/assets/main/main3/main3img3.png'
import main3img4 from '@/assets/main/main3/main3img4.png'
import mo_main3img1 from '@/assets/main/main3/mo_main3img1.png'
import mo_main3img2 from '@/assets/main/main3/mo_main3img2.png'
import mo_main3img3 from '@/assets/main/main3/mo_main3img3.png'
import mo_main3img4 from '@/assets/main/main3/mo_main3img4.png'
import main7_luck_icon0 from '@/assets/main/main7/main7luck_icon0.png'
import main7_luck_icon1 from '@/assets/main/main7/main7luck_icon1.png'
import main7_luck_icon2 from '@/assets/main/main7/main7luck_icon2.png'
import main7_luck_icon3 from '@/assets/main/main7/main7luck_icon3.png'
import main7_luck_icon4 from '@/assets/main/main7/main7luck_icon4.png'
import main7_luck_icon5 from '@/assets/main/main7/main7luck_icon5.png'
import main7_luck_icon6 from '@/assets/main/main7/main7luck_icon6.png'
import main7_luck_icon7 from '@/assets/main/main7/main7luck_icon7.png'
import main7_luck_icon8 from '@/assets/main/main7/main7luck_icon8.png'
import main7_luck_icon9 from '@/assets/main/main7/main7luck_icon9.png'
import main7_luck_icon10 from '@/assets/main/main7/main7luck_icon10.png'
import main7_luck_icon11 from '@/assets/main/main7/main7luck_icon11.png'
import main7_luck_icon12 from '@/assets/main/main7/main7luck_icon12.png'
import main7_luck_icon13 from '@/assets/main/main7/main7luck_icon13.png'
import main7_luck_icon14 from '@/assets/main/main7/main7luck_icon14.png'
import main7_luck_icon15 from '@/assets/main/main7/main7luck_icon15.png'
import main7_luck_icon16 from '@/assets/main/main7/main7luck_icon16.png'

type main3ItemType = {
  title: string
  desc: string
  imgSrc: string
  moImgSrc: string
}

type main7ItemType = {
  idx: number
  title: string
  imgSrc: string
  text: any
}

export const main3ScrollItem: main3ItemType[] = [
  {
    title: '휴대폰 충격알림',
    desc: '휴대폰에 충격이 감지된 후 3분의 시간동안 [괜찮아요]를 누르지 않으면 연결된 구성원에게 자동으로 알림을 보내요.<br/><span class="gray-text">*안드로이드 전용 기능</span>',
    imgSrc: main3img1,
    moImgSrc: mo_main3img1,
  },
  {
    title: '미사용감지',
    desc: '12~24시간 동안 휴대폰 사용이 없으면 앱에서 자동으로 안부확인을 위해 안심콜 기능이 실행되요. 전화 응답이 없으면 위급상황으로 판단되니 안심메시지와 영상통화를 통해 상태를 확인해보세요.',
    imgSrc: main3img2,
    moImgSrc: mo_main3img2,
  },
  {
    title: '패밀리공간',
    desc: '구성원의 위치와 상태를 아이콘으로 확인하고 소통할 수 있는 다양한 기능들을 사용해 보세요.',
    imgSrc: main3img3,
    moImgSrc: mo_main3img3,
  },
  {
    title: '긴급호출',
    desc: '긴급호출 요청 시 연결된 구성원에게 자동으로 알림을 보내고 사이렌 및 플래시를 실행시켜 주변에 도움을 요청해요.',
    imgSrc: main3img4,
    moImgSrc: mo_main3img4,
  },
]
export const main7Item: main7ItemType[] = [
  {
    idx: 0,
    title: '총운',
    imgSrc: main7_luck_icon0,
    text: '백인작지 연록장구라, 백 사람이 함께 농사를 지으니 협동으로 좋은 결과를 기대하기 쉽습니다. 칠년 가뭄끝에 단비를 만나게 되었으니 이보다 더 기쁜일이 있을 수 없습니다. 출입하면 길함이 있으니 반드시 공명을 얻게 될 것입니다. 밖으로는 대단한 부자이나 안으로는 상대적으로 수익이 적으니 관리에 신경써야 합니다. 사람들이 있어 많이 도와주니 이익이 그 가운데에서 생깁니다. 괴롭다가도 곧 편안함을 얻게되니 뜻밖에 재물이 생길 수입니다. 재물이 생기는 도리는 말하는 구변과 문서로써 이룩되니 관심을 쏟을 일입니다. 바다에 숨어 있는 용의 뜻이니 측량할 수 없습니다. 음지에 봄이 돌아왔으니 만물이 드디어 회생하는 형세입니다. 바다에 숨은 용처럼 웅지를 가져야 합니다.',
  },
  {
    idx: 1,
    title: '직장운',
    imgSrc: main7_luck_icon1,
    text: '이성과의 관계는 발전적인 영향을 타고 있으므로 좋은 결실을 기대할 수 있겠습니다.<br/> <br/> 다만 새로 시작하는 관계는 스타트가 느려 답답한 감이 없지 않으며, 어느정도 시간이 흐른 경우에는 본격적으로 가까워 지는 계기를 만나게 된다 할 수 있겠습니다. 애정문제를 보면 전생에 못다한 인연을 만나는 형상이니 특별한 연분을 만나는 일진이 되겠습니다.<br/><br/>자신의 내부적인 문제와 외부적인 환경을 극복하면 정열적으로 만남이 이루어질 수 있습니다.',
  },
  {
    idx: 2,
    title: '금전운',
    imgSrc: main7_luck_icon2,
    text: '타고난 복록은 크지 않더라도 워낙 근검 절약하는 성격을 갖고 있으므로 생활의 궁핍함은 겪지 않고 살아갑니다. 따라서 저금통장에는 늘 잔고가 충분할만큼 돈이 들어있고 계획한 수입 지출 내역대로 살림이 꾸려져 나갑니다. 주변에는 돈을 꿔달라는 사람들이 많이 있는데 이들은 마음이 모질지 못해서 손해볼 줄 알면서도 돈 부탁을 거절하지 못하는 유약함이 숨셔져 있고 사람들은 이런 기질을 이용하기 때문입니다.',
  },
  {
    idx: 3,
    title: '소망운',
    imgSrc: main7_luck_icon3,
    text: '소원하는 일은 현실과 맞지 않는 계획을 무리하게 잡고 있는 형강이니 성취되기 위해서 많은 노력이 필요합니다.<br/> <br/>무슨일이든 남의 말만 듣고 결정하지 말고 깊이 생각한 뒤에 후회가 없도록 자신이 판단하시기 바랍니다.<br/> <br/>욕심은 버리고 마음을 비워 정리하는 시간을 가지시기 바랍니다.',
  },
  {
    idx: 4,
    title: '방위운',
    imgSrc: main7_luck_icon4,
    text: '2월과 8월생 원숭이띠는 이사나 직업 변동수가 보이니 계획을 세웠던 이동이라면 주택의 이사나 새로 점포를 내는 일도 길합니다.<br/> <br/>여행은 남동쪽이 행운의 방향이니 계획에 참고하시고 행운의 색은 연두색과 회색입니다.<br/><br/>검은 색 옷을 입으면 구설을 불러오겠으니 피해야만 합니다.',
  },
  {
    idx: 5,
    title: '쥐띠',
    imgSrc: main7_luck_icon5,
    text: '어디론가 떠나고 싶다는 생각이 난다면 모든 것을 다 떨쳐버리고 과감하게 떠나는 것도 좋겠다. 오히려 힘들고 어려울 때 일수록 집착하지 말고 잠시 한 호흡 멈추고 뒤돌아서서 생각하는 것도 고려해 볼 만하다. <br/> <br/>48년생 동쪽이 이로우니 출입하게 되면 하는 일마다 빛이 나고 이득을 얻는다.<br/>60년생 끈기 있게 재도전하여 길을 찾아라. 힘들다고 포기하면 안된다.<br/>72년생 형식과 절차를 제대로 갖추어야 한다. 대충하면 나중에 문제가 된다.<br/>84년생 사람을 너무 믿지 마라. 남의 말을 그대로 믿었다가는 금전적인 손해를 볼 수 있다.<br/>96년생 문제가 있는 것을 외면하지 말아야 한다. 더 큰 문',
  },
  {
    idx: 6,
    title: '소띠',
    imgSrc: main7_luck_icon6,
    text: '의기소침하지 말고 다시한 번 용기를 내어 도전하십시오.<br/> <br/>49년생 바라는 바가 너무 큰 게 탈입니다. 인생사 욕심낸들 무슨 소용인가?<br/>61년생 스스로를 위로하십시오.<br/>73년생 상대가 먼저 화해 요청하게 됩니다. 받아들이세요.<br/>85년생 연인이나 부부사이의 다툼은 금물. 서로 조금씩 양보하십시오.<br/>97년생 어디를가도 반기는 이 없으니 슬프구나. 오늘은 근신할 때입니다.',
  },
  {
    idx: 7,
    title: '호랑이띠',
    imgSrc: main7_luck_icon7,
    text: '세상은 혼자 살아갈 수 없는 법. 주위와 협동하십시오.<br/> <br/>50년생 무작정 벌인다고 성공할 수 없는 법.<br/>62년생 시기적으로 거래를 성사시키기는 어렵겠습니다.<br/> 74년생 주의사람과 상의하여 함께 도모해야 합니다.<br/>86년생 동남방이 길방입니다. 재물은 크게 들어오지 못합니다.<br/> 98년생 연인이나 부부사이의 다툼은 금물. 서로 조금씩 양보하십시오.',
  },
  {
    idx: 8,
    title: '토끼띠',
    imgSrc: main7_luck_icon8,
    text: '어디론가 떠나고 싶다는 생각이 난다면 모든 것을 다 떨쳐버리고 과감하게 떠나는 것도 좋겠다. 오히려 힘들고 어려울 때 일수록 집착하지 말고 잠시 한 호흡 멈추고 뒤돌아서서 생각하는 것도 고려해 볼 만하다. <br/> <br/> 51년생 동쪽이 이로우니 출입하게 되면 하는 일마다 빛이 나고 이득을 얻는다.<br/> 63년생 끈기 있게 재도전하여 길을 찾아라. 힘들다고 포기하면 안된다.<br/> 75년생 형식과 절차를 제대로 갖추어야 한다. 대충하면 나중에 문제가 된다.<br/> 87년생 사람을 너무 믿지 마라. 남의 말을 그대로 믿었다가는 금전적인 손해를 볼 수 있다.',
  },
  {
    idx: 9,
    title: '용띠',
    imgSrc: main7_luck_icon9,
    text: '의기소침하지 말고 다시한 번 용기를 내어 도전하십시오.<br/> <br/> 52년생 바라는 바가 너무 큰 게 탈입니다. 인생사 욕심낸들 무슨 소용인가?<br/> 64년생 스스로를 위로하십시오.<br/> 76년생 상대가 먼저 화해 요청하게 됩니다. 받아들이세요.<br/> 88년생 연인이나 부부사이의 다툼은 금물. 서로 조금씩 양보하십시오.',
  },
  {
    idx: 10,
    title: '뱀띠',
    imgSrc: main7_luck_icon10,
    text: '세상은 혼자 살아갈 수 없는 법. 주위와 협동하십시오.<br/> <br/> 53년생 무작정 벌인다고 성공할 수 없는 법.<br/> 65년생 시기적으로 거래를 성사시키기는 어렵겠습니다.<br/> 77년생 주의사람과 상의하여 함께 도모해야 합니다.<br/> 89년생 동남방이 길방입니다. 재물은 크게 들어오지 못합니다.\n',
  },
  {
    idx: 11,
    title: '말띠',
    imgSrc: main7_luck_icon11,
    text: '어디론가 떠나고 싶다는 생각이 난다면 모든 것을 다 떨쳐버리고 과감하게 떠나는 것도 좋겠다. 오히려 힘들고 어려울 때 일수록 집착하지 말고 잠시 한 호흡 멈추고 뒤돌아서서 생각하는 것도 고려해 볼 만하다. <br/> <br/>54년생 끈기 있게 재도전하여 길을 찾아라. 힘들다고 포기하면 안된다.<br/>66년생 형식과 절차를 제대로 갖추어야 한다. 대충하면 나중에 문제가 된다.<br/> 78년생 사람을 너무 믿지 마라. 남의 말을 그대로 믿었다가는 금전적인 손해를 볼 수 있다.<br/>90년생 문제가 있는 것을 외면하지 말아야 한다. 더 큰 문',
  },
  {
    idx: 12,
    title: '양띠',
    imgSrc: main7_luck_icon12,
    text: '의기소침하지 말고 다시한 번 용기를 내어 도전하십시오.<br/> <br/> 55년생 스스로를 돌보고 위로하십시오.<br/> 67년생 상대가 먼저 화해 요청하게 됩니다. 받아들이세요.<br/> 79년생 연인이나 부부사이의 다툼은 금물. 서로 조금씩 양보하십시오.<br/> 91년생 어디를가도 반기는 이 없으니 슬프구나. 오늘은 근신할 때입니다.',
  },
  {
    idx: 13,
    title: '원숭이띠',
    imgSrc: main7_luck_icon13,
    text: '세상은 혼자 살아갈 수 없는 법. 주위와 협동하십시오.<br/> <br/> 56년생 무작정 벌인다고 성공할 수 없는 법.<br/> 68년생 시기적으로 거래를 성사시키기는 어렵겠습니다.<br/> 80년생 주의사람과 상의하여 함께 도모해야 합니다.<br/> 92년생 동남방이 길방입니다. 재물은 크게 들어오지 못합니다.',
  },
  {
    idx: 14,
    title: '닭띠',
    imgSrc: main7_luck_icon14,
    text: '어디론가 떠나고 싶다는 생각이 난다면 모든 것을 다 떨쳐버리고 과감하게 떠나는 것도 좋겠다. 오히려 힘들고 어려울 때 일수록 집착하지 말고 잠시 한 호흡 멈추고 뒤돌아서서 생각하는 것도 고려해 볼 만하다. <br/> <br/> 57년생 동쪽이 이로우니 출입하게 되면 하는 일마다 빛이 나고 이득을 얻는다.<br/> 69년생 형식과 절차를 제대로 갖추어야 한다. 대충하면 나중에 문제가 된다.<br/> 81년생 사람을 너무 믿지 마라. 남의 말을 그대로 믿었다가는 금전적인 손해를 볼 수 있다.<br/> 92년생 상대가 먼저 화해 요청하게 됩니다. 받아들이세요.',
  },
  {
    idx: 15,
    title: '개띠',
    imgSrc: main7_luck_icon15,
    text: '의기소침하지 말고 다시한 번 용기를 내어 도전하십시오.<br/> <br/> 58년생 바라는 바가 너무 큰 게 탈입니다. 인생사 욕심낸들 무슨 소용인가?<br/> 70년생 스스로를 돌보고 위로하십시오.<br/> 82년생 상대가 먼저 화해 요청하게 됩니다. 받아들이세요.<br/> 94년생 연인이나 부부사이의 다툼은 금물. 서로 조금씩 양보하십시오.',
  },
  {
    idx: 16,
    title: '돼지띠',
    imgSrc: main7_luck_icon16,
    text: '세상은 혼자 살아갈 수 없는 법. 주위와 협동하십시오.<br/> <br/> 59년생 무작정 벌인다고 성공할 수 없는 법.<br/> 71년생 시기적으로 거래를 성사시키기는 어렵겠습니다.<br/> 83년생 주의사람과 상의하여 함께 도모해야 합니다.<br/> 95년생 동남방이 길방입니다. 재물은 크게 들어오지 못합니다.',
  },
]
